import { useTranslation } from "react-i18next";
import { NAME_SPACES } from "shared/locales/constants";
import Navbar from "../Components/Navbar/Navbar";
import View from "./View";

const SubscriptionDone = ({ project, onBack, currentStatus }) => {
  const { t } = useTranslation(NAME_SPACES.PUBLIC.PROCESSES);
  const TRANSLATION = t("B2C_MILTIS.SUBSCRIPTION_DONE", {
    returnObjects: true,
  });
  return (
    <>
      <Navbar
        project={project}
        progress={currentStatus?.progress}
        showHelp={false}
        step={5}
        stepCount={5}
        title={TRANSLATION?.NAVBAR?.TITLE || "Bienvenu à Mobilité Mutuelle"}
      />
      <View onBack={onBack} translate={TRANSLATION} />
    </>
  );
};

export default SubscriptionDone;
